import React, { FC, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

import api from '../../api/api'
import { Button, Link } from '../common'
import styles from './cookie-consent.module.scss'

const COOKIE_CONSENT_KEY = 'cookieConsentAccepted'
const COOKIE_CONSENT_ANONYMOUS_ID_KEY = 'cookieConsentAnonymousId'
const COOKIE_POLICY_VERSION = '2026-07-17'
const COOKIE_CONSENT_TEXT_VERSION = '2026-07-17'

const hasCookieConsent = () => {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted'
  } catch {
    return false
  }
}

const generateAnonymousId = () => {
  if (window.crypto?.getRandomValues) {
    const values = new Uint32Array(4)
    window.crypto.getRandomValues(values)
    return Array.from(values, (value) => value.toString(16).padStart(8, '0')).join('')
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`
}

const getAnonymousId = () => {
  try {
    const savedAnonymousId = localStorage.getItem(COOKIE_CONSENT_ANONYMOUS_ID_KEY)
    if (savedAnonymousId) return savedAnonymousId

    const anonymousId = generateAnonymousId()
    localStorage.setItem(COOKIE_CONSENT_ANONYMOUS_ID_KEY, anonymousId)
    return anonymousId
  } catch {
    return generateAnonymousId()
  }
}

const CookieConsent: FC = () => {
  const [visible, setVisible] = useState(false)
  const [closing, setClosing] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setVisible(!hasCookieConsent())
  }, [])

  const handleAccept = async () => {
    setSaving(true)

    try {
      await api.feedback.postCookieConsent({
        anonymousId: getAnonymousId(),
        path: `${window.location.pathname}${window.location.search}`,
        policyVersion: COOKIE_POLICY_VERSION,
        consentTextVersion: COOKIE_CONSENT_TEXT_VERSION,
      })
    } catch {
      setSaving(false)
      return
    }

    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
    } catch {
      // Ignore unavailable storage and hide the banner for the current session.
    }

    setClosing(true)
    window.setTimeout(() => {
      setVisible(false)
    }, 250)
  }

  if (!visible) return null

  return ReactDOM.createPortal(
    <div className={`${styles.cookieConsent} ${closing ? styles.closing : ''}`} data-cookie-consent>
      <div className={styles.text}>
        На нашем сайте используются cookie-файлы. Продолжая пользоваться данным сайтом, вы подтверждаете свое согласие
        на использование файлов cookie в соответствии с настоящим уведомлением и{' '}
        <Link to={'/confidentiality-policy'}>Политикой в отношении обработки персональных данных</Link>
      </div>
      <Button type="primary" className={styles.button} onClick={handleAccept} disabled={saving}>
        Принимаю
      </Button>
    </div>,
    document.body,
  )
}

export default CookieConsent
